import React from "react";
import { MyContextSupply } from "../../Context";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Option = ({ item }) => {
  const { handleAddProduct, handleRemoveProduct, deleteSingleItem } = MyContextSupply();
  const { setAccount } = MyContextSupply();

  return (
    <div className="add_remove_select">
      <div className="button-add-remove">
        <RemoveIcon
          onClick={() => handleRemoveProduct(item)}
          className="add-icon-cart add-icon-cart-one"
        />
        {item && item?.quantity}
        <AddIcon
          onClick={() => handleAddProduct(item)}
          className="add-icon-cart add-icon-cart-two"
        />
        
      </div>
      <button onClick={() => deleteSingleItem(item)} style={{ cursor: "pointer" }}className="btn-remove-cart-item cart_remove_single">Remove</button>
    </div>
  );
};

export default Option;
